/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { type TemplateCardType } from 'embercom/lib/ai-content-library/constants';
import { EntityType } from 'embercom/models/data/entity-types';
import { tracked } from '@glimmer/tracking';

interface Args {
  onCreateText: () => void;
  onCreatePublicUrl: () => void;
  onCreateFile: () => void;
  mode?: string;
  hasAppliedFilter: boolean;
  templates: Array<TemplateCardType>;
}

export default class EmptyState extends Component<Args> {
  @service declare appService: AppService;
  @tracked showZendeskConnectDrawer = false;
  @tracked showSalesforceConnectDrawer = false;

  get app() {
    return this.appService.app;
  }

  get shouldShowZendeskConnectScreen() {
    return (
      // TODO: SA Generic platform migration – These buttons should work for all platforms
      this.app.hasStandalonePlatform('zendesk') &&
      !this.appService.mainStandalonePlatform.historicalSyncingEnabled
    );
  }

  get shouldShowSalesforceConnectScreen() {
    return (
      // TODO: SA Generic platform migration – These buttons should work for all platforms
      this.app.hasStandalonePlatform('salesforce') &&
      !this.appService.mainStandalonePlatform.historicalSyncingEnabled
    );
  }

  @action
  onClick(entityType: EntityType) {
    switch (entityType) {
      case EntityType.ContentSnippet:
        this.args.onCreateText();
        break;
      case EntityType.ExternalContent:
        this.args.onCreatePublicUrl();
        break;
      case EntityType.FileSourceContent:
        this.args.onCreateFile();
        break;
      default:
    }
  }

  @action
  closeZendeskConnectDrawer() {
    this.showZendeskConnectDrawer = false;
  }

  @action
  openZendeskConnectDrawer() {
    this.showZendeskConnectDrawer = true;
  }

  @action openSalesforceConnectDrawer() {
    this.showSalesforceConnectDrawer = true;
  }

  @action closeSalesforceConnectDrawer() {
    this.showSalesforceConnectDrawer = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentService::AiContentLibrary::EmptyState': typeof EmptyState;
  }
}
